module.exports = __webpack_public_path__ + "static/img/logo.fce6852.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/icon/logo.jpg
// module id = XLS0
// module chunks = 11